import { MediaConfig } from '../dataTypes'
import { UnoRvmPreview } from './rvm-previews/UnoRvmPreview'
import { MediaPreview } from './MediaPreview'
import React, { useState } from 'react'

type Props = {
  mediaConfig: MediaConfig
  additionalMedia: MediaConfig[]
}

type Tab = 'border' | 'idle' | 'receipt'

function TabLink({
  name,
  title,
  activeTab,
  setActiveTabFn,
}: {
  name: Tab
  title: string
  activeTab: Tab
  setActiveTabFn: React.Dispatch<Tab>
}) {
  return activeTab === name ? (
    <span className="font-bold">{title}</span>
  ) : (
    <button
      className="link mx-sm"
      onClick={(e) => {
        e.preventDefault()
        setActiveTabFn(name)
      }}
    >
      {title}
    </button>
  )
}

export const SingleBorderPreview = ({ mediaConfig, additionalMedia }: Props) => {
  const [activeTab, setActiveTab] = useState('border' as Tab)
  console.log('Rendring SingleBorderPreview')
  const idleMedia = additionalMedia.find((p) => p.mediaType === 'IDLE')
  if (!idleMedia) {
    return <div className="alert alert-danger">Error: Idle MediaConfig not found!</div>
  }
  const waitMedia = additionalMedia.find((p) => p.mediaType === 'WAIT')
  if (!waitMedia) {
    return <div className="alert alert-danger">Error: Wait MediaConfig not found!</div>
  }
  return (
    <div className="my-sm">
      <div className={'px-3' + (activeTab === 'border' ? '' : ' hidden')}>
        <MediaPreview media={mediaConfig} />
      </div>

      <div className={'px-3' + (activeTab === 'idle' ? '' : ' hidden')}>
        <UnoRvmPreview borderMediaConfig={mediaConfig} media={idleMedia} />
      </div>

      <div className={'px-3' + (activeTab === 'receipt' ? '' : ' hidden')}>
        <UnoRvmPreview borderMediaConfig={mediaConfig} media={waitMedia} />
      </div>

      <div className="flex justify-around max-screen-xs">
        <TabLink name="border" title="Border image" activeTab={activeTab} setActiveTabFn={setActiveTab} />
        <TabLink name="idle" title="Idle" activeTab={activeTab} setActiveTabFn={setActiveTab} />
        <TabLink name="receipt" title="Receipt" activeTab={activeTab} setActiveTabFn={setActiveTab} />
      </div>
    </div>
  )
}
